import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import _ from 'lodash'

// import Cell from './Cell'

import './style.scss'

const areEqual = (prevProps, nextProps) => _.isEqual(prevProps, nextProps)

const WrappedCell = ({ cell, cellIndex, cellProps, style }) => {
  const { extraClasses: cellExtraClasses = 'text-right' } = cellProps
  // const formattedCell = Array.isArray(cellElements) ? cellElements : [cellElements]

  return (
    <div
      role="cell"
      style={style}
      className={classnames('fil-table--body-row-cell', {
        [cellExtraClasses]: cellExtraClasses,
        'fil-table-row--first-cell': cellIndex === 0
      })}
      // aria-label={cellIndex === 0 && rowProps.isSelectable ? 'Row Selector' : 'Column'}
      // colSpan={rowProps.colspan}
    >
      <div className="fil-table--body-row-cell-content">
        {/* {cellIndex === 0 && rowProps.isSelectable && getRowSelector(row, rowIndex, groupIndex)} */}
        <span>
          {/* {formattedCell.map((cellItem) => (
            <React.Fragment key={`table--cell-${cellIndex}}`}>{cellItem(rowProps)}</React.Fragment>
          ))} */}
          {cell}
        </span>
      </div>
    </div>
  )
}

WrappedCell.propTypes = {
  cell: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired,
  cellIndex: PropTypes.number.isRequired,
  cellProps: PropTypes.object,
  style: PropTypes.object
}

WrappedCell.defaultProps = {
  cellProps: {},
  style: {}
}

export default React.memo(WrappedCell, areEqual)
